import { FontWeights, getTheme, IButtonStyles, Icon, IIconProps, mergeStyleSets } from "@fluentui/react";
import React from "react";
import { FormTreeSelection } from "../../../cpm/FormTree";

interface FormDropDownProps {
  isModalOpen: boolean;
}

const useFormDropDown = (input) => {
  // eslint-disable-next-line no-undef
  const onRenderCaretDown = (): JSX.Element => {
    return isComponentInstance ? null : <Icon iconName="More" />;
  };

  const theme = getTheme();
  const contentStyles = mergeStyleSets({
    header: [
      theme.fonts.xLarge,
      {
        flex: "1 1 auto",
        borderTop: `4px solid ${theme.palette.themePrimary}`,
        color: theme.palette.neutralPrimary,
        display: "flex",
        alignItems: "center",
        fontWeight: FontWeights.semibold,
        padding: "12px 12px 14px 24px",
      },
    ],
    body: {
      flex: "4 4 auto",
      padding: "0 24px 24px 24px",
      overflowY: "hidden",
      selectors: {
        p: { margin: "14px 0" },
        "p:first-child": { marginTop: 0 },
        "p:last-child": { marginBottom: 0 },
      },
    },
    container: {
      display: "flex",
      flexFlow: "column nowrap",
      alignItems: "stretch",
    },
  });
  const iconButtonStyles: Partial<IButtonStyles> = {
    root: {
      color: theme.palette.neutralPrimary,
      marginLeft: "auto",
      marginTop: "4px",
      marginRight: "10px",
    },
    rootHovered: {
      color: theme.palette.neutralDark,
    },
  };

  const cancelIcon: IIconProps = { iconName: "Cancel" };

  const [state, setState] = React.useState<FormDropDownProps>({
    isModalOpen: false,
  });

  const { isModalOpen } = state;
  const { form, dbApplication, objectSource, isComponentInstance, isLocked } = input;

  function onFormClick(formSelection: FormTreeSelection) {
    setState({ ...state, isModalOpen: false });
    input.onFormClick(formSelection);
  }

  return {
    form,
    onRenderCaretDown,
    setState,
    state,
    dbApplication,
    objectSource,
    isModalOpen,
    contentStyles,
    iconButtonStyles,
    cancelIcon,
    onFormClick,
    isComponentInstance,
    isLocked,
  };
};

export default useFormDropDown;
